import React, { useEffect, useState } from "react";
import { updateVpasLimit, viewVpas } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import { CiEdit } from "react-icons/ci";
import { toast } from "react-toastify";
import DataTable from "../../../components/common/DataTable/DataTable";
import Spinner from "../../Spin/Spinner";

const VpaUsageTable = () => {
  const token = useSelector((store) => store.userReducer.token);
  const [isLoading, setIsLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [totalLimit, setTotalLimit] = useState(0);
  const [dailyLimit, setDailyLimit] = useState(0);
  const [updateVpa, setUpdateVpa] = useState(null);

  const fetchAllVpas = async () => {
    try {
      const response = await viewVpas(token);
      setTableData(response || []);
    } catch (error) {
      toast.error("Something went wrong while fetching VPA usage data");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchAllVpas();
  }, []);

  const handleUpdate = async () => {
    try {
      const payload = {
        id: updateVpa,
        totalLimit: Number(totalLimit),
        dailyLimit: Number(dailyLimit),
      };
      await updateVpasLimit(token, payload);
      toast.success("VPA limits updated successfully");
      setUpdateVpa(null);
      fetchAllVpas();
    } catch (error) {
      toast.error("Something went wrong while updating VPA limits");
      setUpdateVpa(null);
    }
  };

  const columns = [
    {
      header: "Organization Name",
      accessor: "orgName",
      render: (row) => row.orgName || "-",
    },
    {
      header: "VPA",
      accessor: "providerVpa",
      render: (row) => row.providerVpa || "-",
    },
    {
      header: "Usage Today",
      accessor: "usedToday",
      render: (row) => `₹ ${Number(row.usedToday || 0).toFixed(2)}`,
    },
    {
      header: "Daily Limit",
      accessor: "dailyLimit",
      render: (row) => `₹ ${Number(row.dailyLimit || 0).toFixed(2)}`,
    },
    {
      header: "Action",
      accessor: "action",
      render: (row) => (
        <CiEdit
          onClick={() => {
            setUpdateVpa(row.id);
            setTotalLimit(row.totalLimit);
            setDailyLimit(row.dailyLimit);
          }}
          style={{
            width: "1.2rem",
            height: "1.2rem",
            cursor: "pointer",
          }}
        />
      ),
    },
  ];

  return (
    <>
      <div className="main-heading">
        <h2>Check VPA Usage</h2>
        {isLoading ? (
          <Spinner />
        ) : (
          <DataTable
            columns={columns}
            data={tableData}
            emptyMessage="No VPA usage data found."
          />
        )}
      </div>
      {updateVpa && (
        <div className="vpa-modal-overlay">
          <div className="vpa-modal">
            <h3>Update VPA</h3>
            <div>
              <p>Total Limit</p>
              <input
                value={totalLimit}
                onChange={(e) => setTotalLimit(e.target.value)}
                type="number"
                name="totalLimit"
                placeholder="Total Limit"
                required
              />
              <p>Daily Limit</p>
              <input
                value={dailyLimit}
                onChange={(e) => setDailyLimit(e.target.value)}
                name="dailyLimit"
                type="number"
                placeholder="Daily Limit"
                required
              />
              <div className="modal-actions">
                <button type="submit" onClick={handleUpdate}>
                  Update
                </button>
                <button type="button" onClick={() => setUpdateVpa(null)}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VpaUsageTable;
